module.exports = __webpack_public_path__ + "media/mets.8d3519c2.mp3";